module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-italic.882908d9.woff2";